import loadable from '@loadable/component';
import FullPageLoading from '../../components/Loading/FullPageLoading';

export const ChatLoadable = loadable(async () => import('./Conversation/conversation.view'), {
  fallback: <FullPageLoading />,
});
